import axiosInstance from "../utils/axiosInstance";

export const fetchValues = async () => {
    try {
        const response = await axiosInstance.get(`/api/values`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching values:', error);
        return [];
    }
};